import React from 'react';
import { Itemcard } from '../Components/Itemcard/Itemcard';
import vegetables from "../Data/vegetables";
import Banner5 from '../Components/Images/banner5.jpg'
import { Carousel } from '../Components/Carousel/Carousel';

export const Vegetables = () => {
  return (
    <div>
      <div className="banners">
        <Carousel />
      </div>
      <h1 className='text-center mt-5'> Add Items to Cart🙂</h1>
      <section className='py-4 container'>
        <div className='row justify-content-center'>
          {vegetables.productData.map((item, index) => {
            return (
              <Itemcard
                img={item.img}
                title={item.title}
                price={item.price}
                desc={item.desc}
                item={item}
                key={index} />
            )
          })}
        </div>
      </section>
      <div className='footertop'>
        <img src={Banner5} alt="" />
      </div>

    </div>
  )
}
